<template>
  <div class="wrong-entry icon-gxct" @click="viewWrong">
<!--    <span class="title-text">共性错题</span>-->
  </div>
</template>

<script>
  export default {
    name: "index",
    props: {
      currentStudent: {
        type: Object
      }
    },
    methods: {
      viewWrong () {
        this.$router.push({ path: '/supervise/wrong', query: {}});
      }
    }
  }
</script>

<style scoped lang="scss">
  .wrong-entry {
    position: fixed;
    width: 109px;
    height: 98px;
    top: 50%;
    right: 0;
    /*background: #2980FF;*/
    /*border: 1px solid #2980FF;*/
    /*border-radius: 4px;*/
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .title-text {
      width: 19px;
      font-size: 18px;
      color: #FFFFFF;
      letter-spacing: -2.25px;
      line-height: 21px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/wrong/index.vue